import React, {Component} from "react";
import {connect} from "react-redux";
import {cx} from "../../lib/ClassSet";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS} from "immutable";
import {graphql} from "react-apollo";
import EmptyStatus from "../../components/EmptyStatus";
import {SHIPPING_ADDRESSES, ON_SHIPPING_ADDRESSES_UPDATED} from "../../queries/shipping";
import "./AddressList.css";

class AddressList extends Component {

  UNSAFE_componentWillMount() {
    this.props.subscribeToUpdates(this.props, {}); 
  }

  render() {
    let {loading, error, shippingAddresses} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    if (shippingAddresses.length === 0) return <EmptyStatus status="No addresses found" />
    return (
      <div className="AddressList">
        {this.renderAddresses(fromJS(shippingAddresses))}
      </div>
    )
  }

  renderAddresses(addresses) {
    return addresses.map(address => {
      return (
        <Address
          key={address.get("addressId")}
          address={address}
          onClick={() => this.props.onAddressClick(address)}
          />
      )
    })
  }

}

AddressList.defaultProps = {
  accountId: ""
}

const mapDispatchToProps = dispatch => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_SHIPPING_ADDRESSES_UPDATED,
      variables: {
        accountId: props.accountId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }
})

const withSubscription = connect(null, mapDispatchToProps);

const withQuery = graphql(SHIPPING_ADDRESSES, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      accountId: props.accountId
    }    
  })
})


export default withQuery(withSubscription(AddressList));


function typeToLabel(type) {
  if (type === "home") return "Home address";
  if (type === "business") return "Business address";
  return type;
}

const Address = (props) => {

  let address = props.address;
  let classes = cx({
    "Address": true,
    "u-business": address.get("type") === "business",
    "u-home": address.get("type") === "home",
    "u-addressLine2": address.get("addressAddressLine2", "").length > 0
  })

  return (
    <div className={classes} onClick={props.onClick}>
      <div className="type">{typeToLabel(address.get("type"))}</div>
      <div className="label">{address.get("label")}</div>
      <div className="name">{address.get("name")}</div>
      <div className="address">
        {address.get("addressAddressLine1")}<br/>
        <span className="addressLine2">{address.get("addressAddressLine2", "")}<br/></span>
        {address.get("addressCity")}, {address.get("addressStateProvince")} {address.get("addressPostcode")}<br/>          
        {address.get("addressCountryName")}
      </div>
      <div className="verificationStatus">{address.get("verificationStatus")}</div>
    </div>
  )

}